module.exports = window["grp"];